"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/styles/createStyles.js
// module id = 92
// module chunks = 0